import { useQuery } from '@hooks/reactQuery';

import { getChangeMonitoringUsers } from '@api/manageNetworkElementConfigurations';

import { mapDropdownOptions } from '@utils/formatter';

import { IIsActive } from '@interfaces/common/common';
import { IWithNetworkElementId } from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_CHANGE_MONITORING_USERS } from '@constants/queryKeys';

interface IUseQueryChangeMonitoringUsersReturn {
	isLoadingChangeMonitoringUsers: boolean;
	changeMonitoringUsers: TSelectOptionType<string>[];
}

export const useQueryChangeMonitoringUsers = (
	params: IWithNetworkElementId & IIsActive,
): IUseQueryChangeMonitoringUsersReturn => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [NETWORK_ELEMENT_CHANGE_MONITORING_USERS, params],
		queryFn: () => getChangeMonitoringUsers(params),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		enabled: [!!params.networkElementId],
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'id',
			labelKey: 'fullName',
			additionalMappings: {
				name: 'id',
			},
		}),
		...refetchOptions,
	});

	return {
		isLoadingChangeMonitoringUsers: isInitialLoading,
		changeMonitoringUsers: data || [],
	};
};
